import { Spinner } from 'AWS-UI-Components-React';
import React from 'react';
import { TEXT } from '../reports/common/constants';

export class LoadingSpinner extends React.Component {
  render() {
    return (
      <div>
        <Spinner/>
        <div className="awsui-util-d-ib">{TEXT.LOADING}</div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/content/loading_spinner.jsx